import { _ as o } from "./index904.mjs";
import { _ as r } from "./index905.mjs";
import { _ as i } from "./index906.mjs";
import { _ as h } from "./index907.mjs";
import { _ as p } from "./index908.mjs";
var c = o, C = r, _ = i, m = h, f = p;
function t(e) {
  var a = -1, l = e == null ? 0 : e.length;
  for (this.clear(); ++a < l; ) {
    var s = e[a];
    this.set(s[0], s[1]);
  }
}
t.prototype.clear = c;
t.prototype.delete = C;
t.prototype.get = _;
t.prototype.has = m;
t.prototype.set = f;
var u = t;
export {
  u as _
};
